<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else-if="isStaff">
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="true" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <main class="common-main">
      <h2 class="common-title">相談一覧</h2>

      <!-- 認証済みの時はメインの画面を表示 -->
      <div v-if="signedIn">
        <template v-if="isLoading">
          <div class="loading"></div>
        </template>
        <div v-else-if="hasUserData">
          <template v-if="isAdviser">
          </template>
          <template v-else-if="isStaff">
          </template>
          <template v-else>
            <GuideModuleItem :createButton="true" />
            <br>
          </template>
          <ul class="list-wrap notice-list">
            <li class="list-body" v-for="counseling in counselingData" :key="counseling.id">
              <a v-if="counseling.id" :href="'/counselingDetail/' + counseling.id">
                <div class="list-status">
                  <template v-if="counseling.status === '相談中'">
                    <div class="status-label label-ing">{{counseling.status}}</div>
                  </template>
                  <template v-else>
                    <div class="status-label label-ed">{{counseling.status}}</div>
                  </template>
                  <div class="list-date">{{counseling.createAt | date}}</div>
                </div>
                <div class="list-main">
                  <p class="listbody-text">{{counseling.counselingText | truncate}}</p>
                </div>
                <div class="list-foot">
                  <template v-if="counseling.status === '相談中'">
                    <div class="foot-inner" v-if="counseling.lastResponseReplierType === 'user' || counseling.lastResponseReplierType === null">
                      <template v-if="isAdviser || isStaff">
                        <div v-if="counseling.isOfficialTestAccount" style="color:red; margin:5px">公式テストアカウントによるテスト投稿です</div>
                        <div>相談者：{{counseling.displayName}}</div>
                      </template>
                      <div>カテゴリ：{{counseling.counselingCategory1}} - {{counseling.counselingCategory2}}</div>
                      <div v-if="isAdviser">回答をお願いします</div>
                      <div v-else>回答をお待ちください</div>
                      <div v-if="isAdviser" class="text-red">回答期限： {{counseling.responseEstimatedDate | date('responseEstimatedDate')}}</div>
                      <div v-else class="text-red">回答予定： {{counseling.responseEstimatedDate | date('responseEstimatedDate')}}</div>
                    </div>
                    <div class="foot-inner" v-else>
                      <template v-if="isAdviser || isStaff">
                        <div v-if="counseling.isOfficialTestAccount" style="color:red; margin:5px">公式テストアカウントによるテスト投稿です</div>
                        <div>相談者：{{counseling.displayName}}</div>
                      </template>
                      <div>カテゴリ：{{counseling.counselingCategory1}} - {{counseling.counselingCategory2}}</div>
                      <div class="text-red" v-if="isAdviser">相談者が確認中です</div>
                      <div class="text-red" v-else>回答が来ています</div>
                      <div>{{counseling.lastResponseDate | date}}</div>
                    </div>
                    <div class="avator-icon">
                      <img :src="counseling.iconUrl" alt="" />
                    </div>
                  </template>
                  <template v-else>
                    <div class="foot-inner">
                      <template v-if="isAdviser || isStaff">
                        <div v-if="counseling.isOfficialTestAccount" style="color:red; margin:5px">公式テストアカウントによるテスト投稿です</div>
                        <div>相談者：{{counseling.displayName}}</div>
                      </template>
                      <div>カテゴリ：{{counseling.counselingCategory1}} - {{counseling.counselingCategory2}}</div>
                    </div>
                    <div class="avator-icon">
                      <img :src="counseling.iconUrl" alt="" />
                    </div>
                  </template>
                </div>
              </a>
            </li>
          </ul>
          <template v-if="isAdviser">
          </template>
          <template v-else-if="isStaff">
          </template>
          <template v-else>
            <br>
            <a href="/counselingDetail"><button class="footerNavi-button button-primary">新規相談をする</button></a>
            <br>
          </template>
        </div>





        <div class="text-box" v-else>
          アカウント情報を設定してください
          <a class="link-button" href="/profileSetting">アカウント設定</a>
        </div>
      </div>

      <!-- 認証していない時はログイン画面を表示 -->
      <div v-else>
        <LoginItem :createButton="false" />
      </div>
    </main>
    <template v-if="isAdviser || isStaff">
      <FooterItem :contactUrl="contactUrl" :hiddenFooterFixedButton="true" />
    </template>
    <template v-else>
      <FooterItem :contactUrl="contactUrl" />
    </template>
  </div>
</template>

<script>
import { API, Auth, Storage, graphqlOperation, Analytics, Logger } from "aws-amplify"
//import { AmplifyEventBus } from 'aws-amplify-vue'
import HeaderItem from './Header'
import FooterItem from './Footer'
import LoginItem from './Login'
import GuideModuleItem from './GuideModule'

import { getUser } from "./graphql/queries"
import { listStaffAllowListsBySpecificUser } from './graphql/queries'
import { listUsersBySpecificUser } from "./graphql/queries"

// 相談情報取得
import { listCounselingTopicsBySpecificCounselingUserid } from "./graphql/queries"
import { listCounselingTopicss } from "./graphql/queries"
import { createErrorLog } from "./graphql/mutations"

import { Common } from './Common.js'
import { onAuthUIStateChange } from '@aws-amplify/ui-components';

const logger = new Logger('CounselingList');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'counselingList',
  components : {
    HeaderItem,
    FooterItem,
    LoginItem,
    GuideModuleItem
  },
  mixins:[Common],
  data(){
    return{
      authState: undefined,
      unsubscribeAuth: undefined,
      signedIn: false,
      id: '',
      mailaddress: '',
      userId: '',
      userType: '',
      isAdviser: false,
      isStaff: false,
      hasUserData: false,
      counselingData: [],
      contactUrl: '',
      isLoading: true
    }
  },
  
  filters: {
    truncate: function (value) {
      var length = 50
      var ommision = '...'
      value = value.replace(/<br\s?\/?>/g, ' ')
      if (value.length <= length) {
        return value
      }
      return value.substring(0, length) + ommision
    },
    date: function (value, opt) {
      if (value && opt === 'responseEstimatedDate') {
        var regex1 = /:\d\d\+09:00/gi
        var regex2 = /:\d\d\.\d+Z/gi
        var regex3 = /\+09:00/gi
        return value.replace('T', ' ').replace(regex1, '').replace(regex2, '').replace(regex3, '')
      } else if (value) {
        var valueDate = new Date(value)
        var valueFormat = 'YYYY-MM-DD HH:mm'
        valueFormat = valueFormat.replace(/YYYY/, valueDate.getFullYear())
        
        if (valueDate.getMonth() + 1 < 10) {
          valueFormat = valueFormat.replace(/MM/, '0' + (valueDate.getMonth() + 1))
        } else {
          valueFormat = valueFormat.replace(/MM/, valueDate.getMonth() + 1)
        }
        
        if (valueDate.getDate() < 10) {
          valueFormat = valueFormat.replace(/DD/, '0' + valueDate.getDate())
        } else {
          valueFormat = valueFormat.replace(/DD/, valueDate.getDate())
        }

        if (valueDate.getHours() < 10) {
          valueFormat = valueFormat.replace(/HH/, '0' + valueDate.getHours())
        } else {
          valueFormat = valueFormat.replace(/HH/, valueDate.getHours())
        }

        if (valueDate.getMinutes() < 10) {
          valueFormat = valueFormat.replace(/mm/, '0' + valueDate.getMinutes())
        } else {
          valueFormat = valueFormat.replace(/mm/, valueDate.getMinutes())
        }
        
        return valueFormat
     
      } else {
        return value
      }
    }
  },

  methods: {
    download(key, num, type, i, identityId) {
      Storage.get(key, { level: 'protected', identityId: identityId })
        .then(result => {
          //console.log(result)
          
          if (!key) {
            result = null
          }
          if (type === 'icon' && result) {
            var tmpData = this.counselingData[i]
            tmpData.iconUrl = result
            this.counselingData.splice(i, 1, tmpData)
            return result
          } else {
            /*
            if (num === 1) {
              this.uploadedImage1 = result
            } else if (num === 2) {
              this.uploadedImage2 = result
            } else if (num === 3) {
              this.uploadedImage3 = result
            }
            */
          }
        })
        .catch(err => {
          logger.error(err)
          Analytics.record({
            name: 'errorLog', 
            attributes: { 
              page: 'CounselingList',
              url: window.location.origin + window.location.pathname,
              userid: this.id,
              userType: this.userType,
              counselingTopicsId: this.counselingId,
              errorType: 'Image download : Storage.get',
              errorNumber: 'CounselingList-01',
              errorMessage: err
            }
          });

          const errorLog = {
            type: 'errorLog',
            page: 'CounselingList',
            url: window.location.origin + window.location.pathname,
            userid: this.id,
            userType: this.userType,
            counselingTopicsId: this.counselingId,
            errorType: 'Image download : Storage.get',
            errorNumber: 'CounselingList-01',
            errorMessage: err,
            addUser: 'system',
            createAt: new Date()
          }
          API.graphql(graphqlOperation(
            createErrorLog, { input: errorLog }
          ))
          //alert(err)
          //alert("画像の取得処理に失敗しました")
        })
    },
  },

  beforeDestroy() {
    this.unsubscribeAuth();
  },
  
  async beforeCreate() {
    this.unsubscribeAuth = onAuthUIStateChange(async (authState, authData) => {
      this.authState = authState;
      this.user = authData;
      if (authState === 'signedin') {
        let cognitoUser = await Auth.currentAuthenticatedUser()
        this.signedIn = true
        this.id = cognitoUser.username

        // TODO: ここで hasUserData の確認処理をキックし、リロードの要不要を判定
        location.reload(1)
      } else if (authState === 'signedout') {
        // ログアウト前の情報を破棄
        this.$destroy()
        location.reload(1)
      } else {
        this.signedIn = false
      }
    });
    
    // Auth.currentAuthenticatedUser()でユーザ情報を取得する。
    // 取得できなければ認証ステータスをfalseに設定する
    try {
      let cognitoUser = await Auth.currentAuthenticatedUser()
      this.signedIn = true
      this.id = cognitoUser.username
      this.mailaddress = cognitoUser.attributes.email
    } catch (err) {
      this.signedIn = false
    }

    // 認証情報でUserデータを確認
    try {
      let userData = await API.graphql(graphqlOperation(
        listUsersBySpecificUser, {mailAddress: this.mailaddress, limit: 1}
      ))
      this.userId = userData.data.listUsersBySpecificUser.items[0].id
      this.userType = userData.data.listUsersBySpecificUser.items[0].type
      if (userData.data.listUsersBySpecificUser.items[0].type === 'adviser') {
        this.isAdviser = true
      } else {
        this.isAdviser = false
      }
      if (userData.data.listUsersBySpecificUser.items[0].id) {
        this.hasUserData = true 
      }
      let env = this.getEnv(location.hostname)
      this.appClass = this.getAppDivClass(location.hostname)
      if (this.appClass === 'hama') {
        this.contactUrl = 'https://share.hsforms.com/1qOJQdDxdSbSqrkrMw8jeFA46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // 浜松オンラインがん相談版
      } else {
        this.contactUrl = 'https://share.hsforms.com/1Bs-IcJO-TJOoLtoLHONvYQ46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // CancerWith版
      }
    } catch (err) {
      // 運営アカウントか判定
      try {
        let staffAllowData = await API.graphql(
          graphqlOperation(listStaffAllowListsBySpecificUser, {
            mailAddress: this.mailaddress,
            limit: 1
          })
        )
        if (
          staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].mailAddress ===
          this.mailaddress
        ) {
          // 運営モード
          this.userId = ''
          this.userType = 'adviser'
          this.isAdviser = false
          this.isStaff = true
          this.hasUserData = true
          this.contactUrl = ''
        } else {
          this.userId = ''
          this.userType = ''
          this.isAdviser = false
          this.isStaff = false
          this.hasUserData = false
          this.contactUrl = ''
        }
      } catch (err) {
        this.userId = ''
        this.userType = ''
        this.isAdviser = false
        this.isStaff = false
        this.hasUserData = false
        this.contactUrl = ''
        this.$router.push({ path: '../dashboard' })
      }
    }

    
    // 相談情報を取得
    if (this.isAdviser || this.isStaff) {
      try {
        this.counselingData = await API.graphql(graphqlOperation(
          listCounselingTopicss , {limit: 99999}
        ))
        this.counselingData = this.counselingData.data.listCounselingTopicss.items

        this.counselingData.sort (function(a, b) {
          if (new Date(a.createAt) > new Date(b.createAt)) {
            return -1
          } else {
            return 1
          }
        })

        // アイコン画像取得
        //let iconUrlList = []
        for (let key in this.counselingData) {
          let targetUserid = this.counselingData[key].counselingUserid
          /*
          if (iconUrlList[targetUserid]) {
            // 既に画像取得済み
            let tmpData = this.counselingData[key]
            tmpData.iconUrl = iconUrlList[targetUserid]
            this.counselingData.splice(key, 1, tmpData)
          } else {
            try {
              let userData = await API.graphql(graphqlOperation(
                getUser, {id: targetUserid, limit: 1}
              ))
              let result = this.download(userData.data.getUser.iconImageKey, null, 'icon', key, userData.data.getUser.iconUploadedIdentityId)

              // 登録がなければデフォルトアイコン
              if (!result) {
                result = userData.data.getUser.iconDefaultUrl
              }

              // デフォルトアイコンも無ければ初期アイコン（クローズドテスト参加者のみ該当）
              if (!result) {
                result = 'https://cancerwith.s3-ap-northeast-1.amazonaws.com/profile/default-profile-img.png'
              }

              iconUrlList[targetUserid] = result

              let tmpData = this.counselingData[key]
              tmpData.iconUrl = iconUrlList[targetUserid]
              this.counselingData.splice(key, 1, tmpData)
            } catch (err) {
              // 取得失敗
            }
          }*/
          let userData = await API.graphql(graphqlOperation(
            getUser, {id: targetUserid, limit: 1}
          ))
          let resultIconUrl = null
          let resultDisplayName = null
          if (userData.data.getUser.iconImageKey) {
            this.download(userData.data.getUser.iconImageKey, null, 'icon', key, userData.data.getUser.iconUploadedIdentityId)
          } else {
            // 登録がなければデフォルトアイコン
            resultIconUrl = userData.data.getUser.iconDefaultUrl
          }
          resultDisplayName = userData.data.getUser.displayName

          // デフォルトアイコンも無ければ初期アイコン（クローズドテスト参加者のみ該当）
          if (!resultIconUrl) {
            resultIconUrl = 'https://cancerwith.s3-ap-northeast-1.amazonaws.com/profile/default-profile-img.png'
          }

          let tmpData = this.counselingData[key]
          tmpData.iconUrl = resultIconUrl
          tmpData.displayName = resultDisplayName
          tmpData.isOfficialTestAccount = this.isOfficialTestAccount(userData.data.getUser.mailAddress)
          this.counselingData.splice(key, 1, tmpData)
          this.isLoading = false
        }
      } catch (err) {
        this.counselingData = []
        this.isLoading = false
      }

    } else {
      try {
        this.counselingData = await API.graphql(graphqlOperation(
          listCounselingTopicsBySpecificCounselingUserid, {counselingUserid: this.userId, limit: 99999}
        ))
        this.counselingData = this.counselingData.data.listCounselingTopicsBySpecificCounselingUserid.items

        this.counselingData.sort (function(a, b) {
          if (new Date(a.createAt) > new Date(b.createAt)) {
            return -1
          } else {
            return 1
          }
        })

        // アイコン画像取得
        //let iconUrlList = []
        for (let key in this.counselingData) {
          let targetUserid = this.counselingData[key].counselingUserid
          /*
          if (iconUrlList[targetUserid]) {
            // 既に画像取得済み
            let tmpData = this.counselingData[key]
            tmpData.iconUrl = iconUrlList[targetUserid]
            this.counselingData.splice(key, 1, tmpData)
          } else {
            try {
              let userData = await API.graphql(graphqlOperation(
                getUser, {id: targetUserid, limit: 1}
              ))
              let result = this.download(userData.data.getUser.iconImageKey, null, 'icon', key, userData.data.getUser.iconUploadedIdentityId)

              // 登録がなければデフォルトアイコン
              if (!result) {
                result = userData.data.getUser.iconDefaultUrl
              }

              // デフォルトアイコンも無ければ初期アイコン（クローズドテスト参加者のみ該当）
              if (!result) {
                result = 'https://cancerwith.s3-ap-northeast-1.amazonaws.com/profile/default-profile-img.png'
              }

              iconUrlList[targetUserid] = result

              let tmpData = this.counselingData[key]
              tmpData.iconUrl = iconUrlList[targetUserid]
              this.counselingData.splice(key, 1, tmpData)
            } catch (err) {
              // 取得失敗
            }
          }
          */
         let userData = await API.graphql(graphqlOperation(
            getUser, {id: targetUserid, limit: 1}
          ))
          let result = null
          if (userData.data.getUser.iconImageKey) {
            this.download(userData.data.getUser.iconImageKey, null, 'icon', key, userData.data.getUser.iconUploadedIdentityId)
          } else {
            // 登録がなければデフォルトアイコン
            result = userData.data.getUser.iconDefaultUrl
          }

          // デフォルトアイコンも無ければ初期アイコン（クローズドテスト参加者のみ該当）
          if (!result) {
            result = 'https://cancerwith.s3-ap-northeast-1.amazonaws.com/profile/default-profile-img.png'
          }

          let tmpData = this.counselingData[key]
          tmpData.iconUrl = result
          this.counselingData.splice(key, 1, tmpData)
          this.isLoading = false
        }
      } catch (err) {
        this.counselingData = []
        this.isLoading = false
      }
    }

    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'CounselingList',
        url: window.location.origin + window.location.pathname,
        userid: this.id,
        userType: this.userType
      }
    });

    // GA
    if (location.hostname === 'cancerwith.com') {
      if (this.userType === 'user') {
        this.$gtag.pageview({
          page_path: '/user/counselingList',
          page_title: 'User:相談一覧 (/counselingList)'
        })
      } else if (this.userType === 'adviser') {
        this.$gtag.pageview({
          page_path: '/adviser/counselingList',
          page_title: 'Adviser:相談一覧 (/counselingList)'
        })
      }
    }
  }
};
</script>

<style src="./assets/style.css" />
